var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$_enableCarousel
    ? _c(
        "a",
        {
          staticClass: "owl-carousel owl-theme",
          attrs: {
            id: "owl-carousel-" + _vm._uid,
            href: _vm.itemUrl,
            role: "group"
          }
        },
        [
          _vm._l(_vm.imageUrls, function(imageUrl, index) {
            return _c(
              "div",
              [
                index === 0 && !_vm.disableLazyLoad
                  ? _c("item-lazy-img", {
                      ref: "itemLazyImage",
                      refInFor: true,
                      attrs: {
                        template: "#vue-item-lazy-img",
                        "image-url": imageUrl.url,
                        alt: _vm.getAltText(imageUrl),
                        title: _vm.titleText
                      }
                    })
                  : index !== 0 && !_vm.disableLazyLoad
                  ? _c("img", {
                      staticClass: "img-fluid owl-lazy",
                      attrs: {
                        "data-src": imageUrl.url,
                        alt: _vm.getAltText(imageUrl),
                        title: _vm.titleText
                      }
                    })
                  : _c("img", {
                      staticClass: "img-fluid",
                      attrs: {
                        src: imageUrl.url,
                        alt: _vm.getAltText(imageUrl),
                        title: _vm.getAltText(imageUrl)
                      }
                    })
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            { class: "item-swiper-thumbs item-swiper-thumbs-" + _vm._uid },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.imageUrls, function(imageUrl, index) {
                  return _c("div", {
                    staticClass: "swiper-slide",
                    style: { backgroundImage: "url(" + imageUrl.url + ")" }
                  })
                }),
                0
              )
            ]
          )
        ],
        2
      )
    : _c(
        "a",
        {
          attrs: {
            href: _vm.itemUrl,
            "aria-label": _vm.getAltText(_vm.imageUrls[0])
          }
        },
        [
          !_vm.disableLazyLoad
            ? _c("item-lazy-img", {
                ref: "itemLazyImage",
                attrs: {
                  template: "#vue-item-lazy-img",
                  "image-url": _vm._f("itemImage")(_vm.imageUrls),
                  alt: _vm.getAltText(_vm.imageUrls[0]),
                  title: _vm.titleText
                }
              })
            : _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src: _vm._f("itemImage")(_vm.imageUrls),
                  alt: _vm.getAltText(_vm.imageUrls[0]),
                  title: _vm.titleText
                }
              }),
          _vm._v(" "),
          _c(
            "div",
            { class: "item-swiper-thumbs item-swiper-thumbs-" + _vm._uid },
            [
              _c(
                "div",
                { staticClass: "swiper-wrapper" },
                _vm._l(_vm.imageUrls, function(imageUrl, index) {
                  return _c("div", {
                    staticClass: "swiper-slide",
                    style: { backgroundImage: "url(" + imageUrl.url + ")" }
                  })
                }),
                0
              )
            ]
          )
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }